import config from '@config'

import {
    ACTIVITIES_TRADES_TABLE_CHANGE,
    ACTIVITIES_TRADES_TABLE_CHANGE_REQUEST,
    ACTIVITIES_TRADES_TABLE_DATA_RECEIVED,
    ACTIVITIES_TRADES_TABLE_LOADING_TRUE,
    ACTIVITIES_TRADES_TABLE_LOADING_FALSE,
} from './constants'

export function activitiesTradesTableChange(module, blockKey, id, level, queryParams) {
    return {
        type: ACTIVITIES_TRADES_TABLE_CHANGE,
        data: {
            module,
            id,
            blockKey,
            level,
            queryParams,
        },
    }
}

export function activitiesTradesTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: ACTIVITIES_TRADES_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: config?.api?.report?.[blockKey]?.block?.[2]?.uri,
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function activitiesTradesTableDataReceived(module, id, blockKey, customData) {
    return {
        type: ACTIVITIES_TRADES_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function activitiesTradesTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: ACTIVITIES_TRADES_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function activitiesTradesTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: ACTIVITIES_TRADES_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
